<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title">Πίνακας Εκτύπωσης Παρουσιών</h4> -->
            <div v-if="errorMsg">
              <b-alert show dismissible variant="danger">{{
                errorMsg
              }}</b-alert>
            </div>
            <!-- <p class="card-title-desc"></p> -->
            <div class="col-12">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Από</label>
                    <b-form-input id="example-input" v-model="startDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Μέχρι (Κενό: χθές)</label>
                    <b-form-input id="example-input" v-model="endDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="mt-1">Τμήμα</label>
                    <multiselect v-model="departmentValue" :options="departmentNames" track-by="id" label="name"
                      placeholder="Επιλέξτε Τμήμα" selectLabel="Eπιλογή Τμήματος" selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"></multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-2">
                        <label>Όνομα Χρήστη</label>
                        <multiselect v-model="personOptionValue" :options="peopleOptions" track-by="id" label="name"
                          placeholder="Επιλέξτε Χρήστη" selectLabel="Eπιλογή Χρήστη" selectedLabel="Επιλέχθηκε"
                          deselectLabel="Αποεπιλογή" :multiple="true" :max="1">
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-2">
                        <label class="mb-2">Επιλογή εκτύπωσης</label>
                        <multiselect v-model="printOptionsValue" :options="printOptionsNames" track-by="id" label="name"
                          placeholder="Επιλέξτε Εκτύπωση" selectLabel="Eπιλογή Εκτύπωσης" selectedLabel="Επιλέχθηκε"
                          deselectLabel="Αποεπιλογή"></multiselect>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label>Υπογραφές</label>
                        <multiselect v-model="signatureSelected" :options="signatureOptions" track-by="id" label="name"
                          placeholder="Επιλέξτε Υπογραφή" selectLabel="Eπιλογή Υπογραφής" selectedLabel="Επιλέχθηκε"
                          deselectLabel="Αποεπιλογή"></multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12" style="margin-top:150px;">
              <div class="row">
                <div class="col-md-2">
                  <div class="mt-2">
                    <button class="btn btn-primary" @click.prevent="submitPrinter">
                      Προεπισκόπηση
                    </button>
                  </div>
                </div>
                <!-- <div class="col-md-2">
                  <div class="mt-2">
                    <button
                      class="btn btn-primary"
                      ref="download"
                      id="download"
                      @click.prevent="getSchedule"
                    >
                      Κατεβάστε
                    </button>
                  </div>
                </div> -->
                <b-modal id="modal-center" size="sm" title="Παρακαλώ περιμένετε..." title-class="font-18" hide-footer>
                  <b-spinner v-show="spinnerShow" class="m-2" variant="primary" role="status"></b-spinner>
                  <p>Γίνεται επεξεργασία των στοιχείων</p>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { mapState, mapGetters } from "vuex";
import session from "../../../../api/session";

export default {
  page: {
    title: "Εκτυπωση παρουσιων",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Εκτυπωση παρουσιων",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Εκτύπωση παρουσιών",
          active: true,
        },
      ],

      startDate: "",
      endDate: new Date(Date.now() - 864e5).toISOString().split("T")[0],
      departmentValue: "",
      personID: "",
      signatureSelected: "",
      signaturesOptions: [],
      spinnerShow: false,
      errorMsg: "",
      printOptions: [
        { id: 0, name: "Αναλυτική κατάσταση παρουσιών" },
        { id: 1, name: "Ελλείμματα - Πλεονάσματα / Ανα Ημέρα" },
        // { id: 2, name: "Ελλείμματα - Πλεονάσματα / Ανα Περίοδο", periodic: 1 },
        { id: 6, name: "Ελλείμματα - Πλεονάσματα / Ανα Περίοδο" },
        { id: 7, name: "Ελλείμματα - Πλεονάσματα / Συνολική" },
        { id: 8, name: "Κατάσταση Ωρών Εργασίας" },
        { id: 2, name: "Περιοδική Κατάσταση", periodic: 1 },
        { id: 4, name: "Κατάσταση απόντων - Ανά Ημέρα" },
        { id: 5, name: "Κατάσταση απόντων - Ανά Περίοδο" },
      ],
      printOptionsValue: "",
      personOptionValue: "",
      peopleFilters: {
        department: "",
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["is_staff", "is_superuser", "userLoggedIn"]),
    ...mapState("utils", [
      "departments",
      "peopleOptionFields",
      "departmentOptions",
      "signatures",
    ]),
    // ...mapGetters("utils", ["departmentNames"]),
    departmentNames() {
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    signatureOptions() {
      return this.signatures.map((e) => {
        return { id: e.id, name: e.name };
      });
    },
    printOptionsNames() {
      return this.printOptions.map((e) => {
        return { id: e.id, name: e.name, periodic: e.periodic };
      });
    },
    peopleOptions() {
      if (this.departmentValue && this.departmentValue.id) {
        return this.peopleOptionFields
          .filter((e) => {
            return e.department.includes(this.departmentValue.id);
          })
          .map((e) => {
            return { id: e.id, name: e.person_full_name };
          });
      } else {
        return this.peopleOptionFields.map((e) => {
          return { id: e.id, name: e.person_full_name };
        });
      }
    },
  },
  methods: {
    async fetchElPlPerDayNoDep() {
      const data = {
        start_date: this.startDate,
        end_date: this.endDate,
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
      };
      const params = new URLSearchParams(data);
      this.spinnerShow = true;
      this.$bvModal.show("modal-center");

      await session
        .get(`api/el-pl-no-dep-print-changed/?${params.toString()}`, {
          responseType: "blob",
        })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }
          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinnerShow = false;
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },

    async fetchElPlPeriodicNoDep() {
      const data = {
        start_date: this.startDate,
        end_date: this.endDate,
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
      };
      const params = new URLSearchParams(data);
      this.spinnerShow = true;
      this.$bvModal.show("modal-center");

      await session
        .get(`api/el-pl-periodic-no-dep-print/?${params.toString()}`, {
          responseType: "blob",
        })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }
          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinnerShow = false;
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },

    async fetchDailySummary() {
      const data = {
        start_date: this.startDate,
        end_date: this.endDate,
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
      };
      const params = new URLSearchParams(data);
      this.spinnerShow = true;
      this.$bvModal.show("modal-center");

      await session
        .get(`api/daily-summary-print/?${params.toString()}`, {
          responseType: "blob",
        })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }
          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinnerShow = false;
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },

    async fetchAbsensePerDayNoDep() {
      const data = {
        start_date: this.startDate,
        end_date: this.endDate,
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
      };
      const params = new URLSearchParams(data);
      this.spinnerShow = true;
      this.$bvModal.show("modal-center");

      await session
        .get(`api/absense-people-per-day-no-dep-print/?${params.toString()}`, {
          responseType: "blob",
        })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }
          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinnerShow = false;
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },

    // async fetchAbsensePerDay() {
    //   const data = {
    //     start_date: this.startDate,
    //     end_date: this.endDate,
    //     department:
    //       this.departmentValue && this.departmentValue.id
    //         ? this.departmentValue.id
    //         : "",
    //     person:
    //       this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
    //     signature:
    //       this.signatureSelected && this.signatureSelected.name
    //         ? this.signatureSelected.name
    //         : "",
    //   };
    //   const params = new URLSearchParams(data);
    //   this.spinnerShow = true;
    //   this.$bvModal.show("modal-center");

    //   await session
    //     .get(`api/absense-people-per-day-print/?${params.toString()}`, {
    //       responseType: "blob",
    //     })
    //     .then((resp) => {
    //       this.spinnerShow = false;
    //       this.$bvModal.hide("modal-center");
    //       if (resp.data.type === "application/json") {
    //         this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
    //         return;
    //       }
    //       const blobData = resp.data;
    //       const blob = new Blob([blobData], { type: "application/pdf" });

    //       const objectUrl = URL.createObjectURL(blob);
    //       window.open(objectUrl, "_blank");
    //       this.errorMsg = "";
    //       URL.revokeObjectURL(objectUrl);
    //     })
    //     .catch((e) => {
    //       console.log(e.response.data);
    //       this.spinnerShow = false;
    //       this.errorMsg =
    //         "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
    //       setTimeout(() => {
    //         this.errorMsg = "";
    //       }, 3000);
    //     });
    // },
    async fetchPeriodicAbsense() {
      const data = {
        start_date: this.startDate,
        end_date: this.endDate,
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
      };
      const params = new URLSearchParams(data);
      this.spinnerShow = true;
      this.$bvModal.show("modal-center");

      await session
        .get(`api/absense-people-per-period-print/?${params.toString()}`, {
          responseType: "blob",
        })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }
          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinnerShow = false;
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },
    async submitPrinter() {
      if (!this.printOptionsValue) {
        this.errorMsg = "Παρακαλώ Επιλέξτε Εκτύπωση";
        setTimeout(() => {
          this.errorMsg = "";
        }, 2000);
        return;
      }

      if (this.printOptionsValue.id == 4) {
        await this.fetchAbsensePerDayNoDep();
        return;
      }
      if (this.printOptionsValue.id == 5) {
        await this.fetchPeriodicAbsense();
        return;
      }
      if (this.printOptionsValue.id == 6) {
        await this.fetchElPlPeriodicNoDep();
        return;
      }
      if (this.printOptionsValue.id == 7) {
        await this.fetchElPlPerDayNoDep();
        return;
      }
      if (this.printOptionsValue.id == 8) {
        await this.fetchDailySummary();
        return;
      }

      const data = {
        start_date: this.startDate
          ? this.startDate
          : new Date().toISOString().split("T")[0],
        end_date: this.endDate
          ? this.endDate
          : this.startDate || new Date().toISOString().split("T")[0],
        signature:
          this.signatureSelected && this.signatureSelected.name
            ? this.signatureSelected.name
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        printer:
          this.printOptionsValue && this.printOptionsValue.id > -1
            ? this.printOptionsValue.id
            : "",
        department:
          this.departmentValue && this.departmentValue.id
            ? this.departmentValue.id
            : "",
        periodic:
          this.printOptionsValue && this.printOptionsValue.periodic
            ? this.printOptionsValue.periodic
            : "",
      };
      const params = new URLSearchParams(data);

      this.spinnerShow = true;
      this.$bvModal.show("modal-center");
      await session
        .get(`api/print-analytics/?${params}`, { responseType: "blob" })
        .then((resp) => {
          this.spinnerShow = false;
          this.$bvModal.hide("modal-center");
          if (resp.data.type === "application/json") {
            this.errorMsg = "Δεν βρέθηκαν αποτελέσματα...";
            return;
          }

          const blobData = resp.data;
          const blob = new Blob([blobData], { type: "application/pdf" });

          const objectUrl = URL.createObjectURL(blob);

          if (this.downloadable) {
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = `parousies ${new Date().toLocaleString()}`;
            link.click();
            URL.revokeObjectURL(link.href);
          }

          window.open(objectUrl, "_blank");
          this.errorMsg = "";
          URL.revokeObjectURL(objectUrl);
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinnerShow = false;
          this.errorMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },
  },
};
</script>
